export const minimumRSIValues = {
  roofsBelowAttics: {
    'Zone 4': 6.91,
    'Zone 5': 8.67,
    'Zone 6': 8.67,
    'Zone 7A': 10.43,
    'Zone 7B': 10.43,
    'Zone 8': 10.43,
  },
  roofsCathedral: {
    'Zone 4': 4.67,
    'Zone 5': 4.67,
    'Zone 6': 4.67,
    'Zone 7A': 5.02,
    'Zone 7B': 5.02,
    'Zone 8': 5.02,
  },
  wallsAboveGrade: {
    'Zone 4': 2.78,
    'Zone 5': 3.08,
    'Zone 6': 3.08,
    'Zone 7A': 3.08,
    'Zone 7B': 3.85,
    'Zone 8': 3.85,
  },
  floorsOverUnheated: {
    'Zone 4': 4.67,
    'Zone 5': 4.67,
    'Zone 6': 4.67,
    'Zone 7A': 5.02,
    'Zone 7B': 5.02,
    'Zone 8': 5.02,
  },
  wallsBelowGrade: {
    'Zone 4': 1.99,
    'Zone 5': 2.98,
    'Zone 6': 2.98,
    'Zone 7A': 3.46,
    'Zone 7B': 3.46,
    'Zone 8': 3.97,
  },
  concreteFoundationFloor: {
    'Zone 4': 1.96,
    'Zone 5': 1.96,
    'Zone 6': 1.96,
    'Zone 7A': 3.72,
    'Zone 7B': 3.72,
    'Zone 8': 4.59,
  },
};

export const getMinimumRSI = ({ climateZone, calcId }) => {
  if (!calcId || !climateZone) return null;

  return minimumRSIValues[calcId][climateZone];
};
